import React from 'react';
import { ListView } from 'antd-mobile';
import axios from 'axios';
import AppHeader from './../AppHeader';

var moment = require('moment');

const PAGE_SIZE = 20;
// game_contest.gcontest_type
const GAME_TYPES = { "2d": 1, "3d": 2 };

class RecordHistoryPage extends React.Component {
  constructor(props) {
    super(props);

    this.dataSource = new ListView.DataSource({
      rowHasChanged: (r1, r2) => r1 !== r2
    });

    this.state = {
      step: "2d",
      data: [],
      limit: PAGE_SIZE,
      hasMore: true,
      isLoading: true,
    };

    this.changeSubMenu = this.changeSubMenu.bind(this);
  }

  componentDidMount() {
    this.fetchData("2d", PAGE_SIZE);
  }

  fetchData(step, limit) {
    this.setState({ isLoading: true });

    let dataurl = window.BPdata.apiUrl+'/service/record-history?limit='+limit+'&type='+GAME_TYPES[step];

    axios({
        method: 'get',
        url: dataurl,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Trident-Token" : window.BPdata.token,
          "BP-Agent"         : window.BPdata.rand_compound
      },
    })
    .then(resp => {
        // tab was switched while this request was running
        if (this.state.step !== step) {
          return;
        }

        let rows = (resp.data.data || []).filter(row => row.lottery_number);

        this.setState({
          data: rows,
          limit: limit,
          hasMore: resp.data.total > (resp.data.data || []).length,
          isLoading: false
        });
    })
    .catch(() => {
        this.setState({ isLoading: false });
    });
  }

  onEndReached = () => {
    if (this.state.isLoading || !this.state.hasMore) {
      return;
    }

    this.fetchData(this.state.step, this.state.limit + PAGE_SIZE);
  }

  changeSubMenu(step) {
    if (step === this.state.step) {
      return;
    }

    this.setState({ step: step, data: [], hasMore: true });
    this.fetchData(step, PAGE_SIZE);
  }

  render() {
    const step = this.state.step;

    const row = (obj) => {
      let drawn = moment(obj.schedule_at || obj.expire_date);

      return <div className="bp-card-link bp-card-static bp-compact">
                <div className="bp-card bp-card-row">
                    <span className="bp-card-big bp-record-number">{obj.lottery_number}</span>
                    <span className="bp-record-type">
                        <span className="bp-card-tag">{step.toUpperCase()}</span>
                    </span>
                    <span className="bp-record-date">
                        <span>{drawn.format('DD MMM YYYY')}</span>
                        <span className="bp-card-date">{drawn.format('hh:mm A')}</span>
                    </span>
                </div>
            </div>;
    };

    const footer = () => {
      if (this.state.isLoading) {
        return <div className="text-center" style={{ padding: 20 }}><img src="/img/loading.gif" alt="loading" height="50px" /></div>;
      }

      if (this.state.data.length === 0) {
        return <div className="bp-empty"><h2>အချက်အလက်များရှာမတွေ့ပါ။</h2></div>;
      }

      return "";
    };

    return (
      <div className="page">
        <div className="page-content">
          <AppHeader backLink="/more" titleType="3" title="Record History" isLoading="false" />

          <div className="main-content">
            <div className="row">
              <div className={'grid-50 left text-center tab-holder' + (step === "2d" ? ' active' : '')} onClick={this.changeSubMenu.bind(this, "2d")}>
                2D
              </div>
              <div className={'grid-50 left text-center tab-holder' + (step === "3d" ? ' active' : '')} onClick={this.changeSubMenu.bind(this, "3d")}>
                3D
              </div>
            </div>

            <div className="row text-left">
              <ListView
                dataSource={this.dataSource.cloneWithRows(this.state.data)}
                renderFooter={footer}
                renderRow={row}
                className="am-list"
                pageSize={10}
                useBodyScroll
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RecordHistoryPage;
